// https://github.com/4nduril/simple-mutex-promise

export const getMutex = () => {
  const queue = []
  let busy = 0

  const getLock = () => {
    const isLocked = busy > 0

    const lock = new Promise((resolve) => {
      if (!isLocked) {
        resolve()
        return
      }
      queue.push(resolve)
    })

    busy++

    const releaser = () => {
      const resolve = queue.shift()
      busy--
      if (resolve) {
        resolve()
      }
    }

    return [lock, releaser]
  }
  return { getLock }
}
